import { useEffect } from 'react'
import { Control, FieldErrors, FieldValues, FormState } from 'react-hook-form'
import { View } from 'react-native'
import { useSharedValue } from 'react-native-reanimated'
import { StyleSheet } from 'react-native-unistyles'

import FosterMedicationForm from '@/components/fosters/cards/medications/FosterMedicationForm'
import { useFosterFormContext } from '@/components/fosters/FosterFormContext'
import AccordionItem from '@/components/shared/AccordionItem'
import Species from '@/enums/species'

interface Props<C extends FieldValues, _E extends FieldErrors> {
  control: Control<C, any>
  disabled: boolean
  formState: FormState<C>
  index: number
  open: boolean
  medication?: any
  species: Species
}

const FosterMedicationItemSmall = <
  C extends FieldValues,
  E extends FieldErrors,
>({
  index,
  open,
  ...rest
}: Props<C, E>) => {
  const isExpanded = useSharedValue(open)
  const { setValue } = useFosterFormContext()

  useEffect(() => {
    isExpanded.value = open
  }, [isExpanded, open])

  return (
    <AccordionItem isExpanded={isExpanded} viewKey={`medication_${index}`}>
      <View style={styles.container}>
        <FosterMedicationForm
          pathPrefix={`medications.${index}`}
          setValue={setValue as any}
          {...rest}
        />
      </View>
    </AccordionItem>
  )
}

export default FosterMedicationItemSmall

const styles = StyleSheet.create((theme) => {
  return {
    container: {
      gap: theme.tokens.spacing[2],
      marginTop: theme.tokens.spacing[2],
      paddingHorizontal: theme.tokens.spacing[4],
      width: '100%',
    },
  }
})
